// The list of possible deployment environment names
export abstract class DeploymentEnvironmentConstants {
  public static readonly Local: string = "local-development";
  public static readonly DEV: string = "omnius-development";
  public static readonly SIT: string = "omnius-sit";
  public static readonly UAT: string = "omnius-uat";
  public static readonly Production: string = "omnius-production";
}

export abstract class GlobalConstants {
  public static readonly QuestClientId: number = 1;
}